import React from "react";
import { X, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STEPS = [
  {
    title: "Welcome to Furnace Design Lab 🔥",
    body: "You just unlocked a browser-based prepress studio. Here’s the 30-second tour.",
    cta: "Show me around",
  },
  {
    title: "Start with Halftone Studio",
    body: "Drop art, pick fabric + style, download a press-ready color layer + underbase in seconds.",
    cta: "Next — AI tools",
    link: "/studio/halftone", linkLabel: "Open Halftone Studio",
  },
  {
    title: "AI tools do the boring work",
    body: "AI Vector Creator, Watermark Remover, and Photo Upgrader. Prompt or upload — they run in seconds.",
    cta: "Next — your plan",
  },
  {
    title: "3 free exports / month",
    body: "You’re on Free. Upgrade to Pro ($20/mo), Creator ($45/mo), or Lifetime ($50-$100) anytime from Pricing.",
    cta: "Let me in!",
    link: "/pricing", linkLabel: "See plans",
  },
];

export default function OnboardingTour() {
  const [i, setI] = React.useState(0);
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const seen = localStorage.getItem("fdl_onboarded");
    if (!seen) setVisible(true);
  }, []);

  const close = () => {
    localStorage.setItem("fdl_onboarded", "1");
    setVisible(false);
  };
  const next = () => (i < STEPS.length - 1 ? setI(i + 1) : close());

  if (!visible) return null;
  const s = STEPS[i];
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
      <div className="relative w-full max-w-md rounded-2xl chrome-border p-8">
        <button onClick={close} aria-label="Skip" className="absolute right-4 top-4 text-muted-foreground hover:text-foreground"><X className="h-4 w-4" /></button>
        <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#4aa4ff]/15 text-[#4aa4ff]"><Sparkles className="h-5 w-5" /></div>
        <h2 className="display-font mt-4 text-2xl font-bold">{s.title}</h2>
        <p className="mt-2 text-sm text-muted-foreground">{s.body}</p>
        <div className="mt-8 flex items-center justify-between">
          <div className="flex gap-1">
            {STEPS.map((_, idx) => (
              <span key={idx} className={`h-1.5 w-6 rounded-full ${idx <= i ? "bg-[#4aa4ff]" : "bg-border"}`} />
            ))}
          </div>
          <div className="flex gap-2">
            {s.link && (
              <Link to={s.link} onClick={close}>
                <Button variant="outline" size="sm">{s.linkLabel}</Button>
              </Link>
            )}
            <Button className="btn-ember h-9 px-4 font-semibold" onClick={next}>{s.cta}</Button>
          </div>
        </div>
        <button onClick={close} className="mt-3 text-[11px] text-muted-foreground hover:text-foreground">Skip tour</button>
      </div>
    </div>
  );
}
